<template>
  <kst-page-export-details
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :userData="userData"
      @init="handleExport_Init"
    />

    <kst-check disabled
      v-model="userData.WithDetails"
      :label="Info.Export.Details.Option.Details"
    />
  </kst-page-export-details>
</template>

<script>
import Info from "../RcpyInfo.js";
import Services from "../../../services/Api/RecPayServices.js";

import Export from "./RcpyExD_Export.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    Info: Info,
    userData: {
      ID: null,
      WithDetails: true
    },
    // func
    exportExcelFunc: null
  }),
  methods: {
    /*** by page ***/

    handleInit(id) {
      this.resetData();
      this.userData.ID = id;
    },

    handleExport(loadExport) {
      const config = Services.getExportDetails(this.userData.ID);
      loadExport(config, this.handleExport_Success);
    },
    handleExport_Success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** custom ***/

    resetData() {
      this.userData.ID = null;
      this.userData.WithDetails = true;
    },

    handleExport_Init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    }
  }
}
</script>